<template>
  <figure class="Media" v-if="data">
    <div class="Media_image Media_image_bodymovin" v-if="data.endsWith('.json')" ref="bodymovin" :style="{ opacity: lottieLoaded ? 1 : 0 }"></div>
    <img class="Media_image" :src="data" v-else/>
  </figure>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import lottie from 'lottie-web'

  export default {
    name: "Media",
    props: [ 'data' ],
    mixins: [ scrollUpdate ],
    data() {
      return {
        isShow: false,
        anim: null,
        lottieLoaded: false
      }
    },
    methods: {
      onVisible()
      {
        if(!this.isShow && this.anim)
        {
          this.isShow = true
          this.anim.play()
        }
      },
      onUnVisible()
      {
        if(this.isShow && this.anim)
        {
          this.isShow = false
          this.anim.pause()
        }
      }
    },
    mounted()
    {
      if(this.data && this.data.endsWith(".json"))
      {
        this.anim = lottie.loadAnimation({
          container: this.$refs.bodymovin,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: this.data
        });

        this.anim.addEventListener('DOMLoaded', () => { this.lottieLoaded = true })
      }
    }
  }
</script>

<style lang="stylus" scoped>
.Media

  display block
  margin auto

  &_image

    transition 0.6s $ease

</style>